import { render } from "./ProfileSection.vue?vue&type=template&id=7b6f6870&scoped=true"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"

import "./ProfileSection.vue?vue&type=style&index=0&id=7b6f6870&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6f6870"]])

export default __exports__